












import { computed, defineComponent } from "@vue/composition-api";
import { MessageAttachment } from "@scrile/api-provider/dist/api/MessagesProvider";
import { isAudioFile } from "@/lib/fileHelpers";
import { getMediaThumbnailUrl } from "@/lib/urlHelpers";
import { BlockingStatus } from "@/types";
import MessageMediaItemStatus from "./MessageMediaItemStatus.vue";

export default defineComponent({
  name: "MessageGalleryLocked",
  components: { MessageMediaItemStatus },
  props: {
    attachment: { type: Object as () => MessageAttachment, required: true },
    isAuthor: { type: Boolean, required: true },
    showBlur: { type: Boolean, default: false },
    blockingStatus: { type: Object as () => BlockingStatus, required: true },
  },
  setup(props) {
    const file = computed(() => (isAudioFile(props.attachment.file) ? null : props.attachment.file));
    const converging = computed(() => props.attachment.file.processingStatus !== "OK");
    const src = computed(
      () =>
        (file.value && getMediaThumbnailUrl(file.value, file.value.urlPart, "1080p")) ||
        "/img/content-preview-media.png"
    );

    return {
      src,
      converging,
    };
  },
});
